var { evaluateFormula } = require('../../../../libs/formulaSandbox');

function damparAngleScaleValue(minValue, maxValue, pointValues, formula) {
  var result = 0;

  try {
    // Ensure function is well-formed
    const testFunc = new Function(`return (${formula})`)();

    // **Execute the function inside the sandbox**
    result = evaluateFormula(formula, pointValues || []);

    // Normalize the value to the range [0, 90]
    if (isNaN(minValue) || isNaN(maxValue) || isNaN(result)) {
      return 90;  // Safe default value
    }
    
    if (result <= minValue) return -90;
    if (result >= maxValue) return 0;
    const normalizedValue = -90 + ((result - minValue) / (maxValue - minValue)) * 90;
    return normalizedValue;    

  } catch (err) {
    console.log(err)
  }
  
}

module.exports = damparAngleScaleValue;
